import { defineMessages } from 'react-intl';

const messages = defineMessages({
  accept: {
    id: 'general.accept',
    defaultMessage: 'Accept',
  },
  account: {
    id: 'general.account',
    defaultMessage: 'Account',
  },
  active: {
    id: 'general.active',
    defaultMessage: 'Active',
  },
  all: {
    id: 'general.all',
    defaultMessage: 'All',
  },
  analytics: {
    id: 'general.analytics',
    defaultMessage: 'Analytics',
  },
  archive: {
    id: 'general.archive',
    defaultMessage: 'Archive',
  },
  archived: {
    id: 'general.archived',
    defaultMessage: 'Archived',
  },
  assignTo: {
    id: 'general.assignTo',
    defaultMessage: 'Assign To',
  },
  back: {
    id: 'general.back',
    defaultMessage: 'Back',
  },
  bodyMassIndex: {
    id: 'general.bodyMassIndex',
    defaultMessage: 'Body Mass Index',
  },
  cancel: {
    id: 'general.cancel',
    defaultMessage: 'Cancel',
  },
  city: {
    id: 'general.city',
    defaultMessage: 'City',
  },
  close: {
    id: 'general.close',
    defaultMessage: 'Close',
  },
  confirm: {
    id: 'general.confirm',
    defaultMessage: 'Confirm',
  },
  confirmPassword: {
    id: 'general.confirmPassword',
    defaultMessage: 'Confirm Password',
  },
  copy: {
    id: 'general.copy',
    defaultMessage: 'Copy',
  },
  copyTemplate: {
    id: 'general.copyTemplate',
    defaultMessage: 'Copy Template',
  },
  country: {
    id: 'general.country',
    defaultMessage: 'Country',
  },
  dashboard: {
    id: 'general.dashboard',
    defaultMessage: 'Dashboard',
  },
  delete: {
    id: 'general.delete',
    defaultMessage: 'Delete',
  },
  disconnect: {
    id: 'general.disconnect',
    defaultMessage: 'Disconnect',
  },
  disconnectAllowContentAccess: {
    id: 'general.disconnectAllowContentAccess',
    defaultMessage:
      'Allow the client to keep access to assigned content after disconnecting',
  },
  done: {
    id: 'general.done',
    defaultMessage: 'Done',
  },
  edit: {
    id: 'general.edit',
    defaultMessage: 'Edit',
  },
  energy: {
    id: 'general.energy',
    defaultMessage: 'Energy',
  },
  exit: {
    id: 'general.exit',
    defaultMessage: 'Exit',
  },
  facebook: {
    id: 'general.facebook',
    defaultMessage: 'Facebook',
  },
  finish: {
    id: 'general.finish',
    defaultMessage: 'Finish',
  },
  height: {
    id: 'general.height',
    defaultMessage: 'Height',
  },
  home: {
    id: 'general.home',
    defaultMessage: 'Home',
  },
  instagram: {
    id: 'general.instagram',
    defaultMessage: 'Instagram',
  },
  length: {
    id: 'general.length',
    defaultMessage: 'Length',
  },
  linkedIn: {
    id: 'general.linkedIn',
    defaultMessage: 'LinkedIn',
  },
  logout: {
    id: 'general.logout',
    defaultMessage: 'Logout',
  },
  management: {
    id: 'general.management',
    defaultMessage: 'Management',
  },
  newPassword: {
    id: 'general.newPassword',
    defaultMessage: 'New Password',
  },
  next: {
    id: 'general.next',
    defaultMessage: 'Next',
  },
  none: {
    id: 'general.none',
    defaultMessage: 'None',
  },
  nutrition: {
    id: 'general.nutrition',
    defaultMessage: 'Nutrition',
  },
  ok: {
    id: 'general.ok',
    defaultMessage: 'Ok',
  },
  oldPassword: {
    id: 'general.oldPassword',
    defaultMessage: 'Old Password',
  },
  organizations: {
    id: 'general.organizations',
    defaultMessage: 'Organizations',
  },
  password: {
    id: 'general.password',
    defaultMessage: 'Password',
  },
  profile: {
    id: 'general.profile',
    defaultMessage: 'Profile',
  },
  programs: {
    id: 'general.programs',
    defaultMessage: 'Programs',
  },
  remove: {
    id: 'general.remove',
    defaultMessage: 'Remove',
  },
  resendInvite: {
    id: 'general.resendInvite',
    defaultMessage: 'Resend Invite',
  },
  rolesAndPermissions: {
    id: 'general.rolesAndPermissions',
    defaultMessage: 'Roles & Permissions',
  },
  save: {
    id: 'general.save',
    defaultMessage: 'Save',
  },
  saveAsNew: {
    id: 'general.saveAsNew',
    defaultMessage: 'Save as New',
  },
  search: {
    id: 'general.search',
    defaultMessage: 'Search',
  },
  select: {
    id: 'general.select',
    defaultMessage: 'Select',
  },
  settings: {
    id: 'general.settings',
    defaultMessage: 'Settings',
  },
  statistics: {
    id: 'general.statistics',
    defaultMessage: 'Statistics',
  },
  status: {
    id: 'general.status',
    defaultMessage: 'Status',
  },
  street: {
    id: 'general.street',
    defaultMessage: 'Street',
  },
  submit: {
    id: 'general.submit',
    defaultMessage: 'Submit',
  },
  tags: {
    id: 'general.tags',
    defaultMessage: 'Tags',
  },
  tiktok: {
    id: 'general.tiktok',
    defaultMessage: 'TikTok',
  },
  trainers: {
    id: 'general.trainers',
    defaultMessage: 'Trainers',
  },
  twitter: {
    id: 'general.twitter',
    defaultMessage: 'Twitter',
  },
  unarchive: {
    id: 'general.unarchive',
    defaultMessage: 'Unarchive',
  },
  users: {
    id: 'general.users',
    defaultMessage: 'Users',
  },
  viewProfile: {
    id: 'general.viewProfile',
    defaultMessage: 'View Profile',
  },
  volume: {
    id: 'general.volume',
    defaultMessage: 'Volume',
  },
  weight: {
    id: 'general.weight',
    defaultMessage: 'Weight',
  },
  zip: {
    id: 'general.zip',
    defaultMessage: 'Zip code',
  },
});

export default messages;
